import styled from 'styled-components'

export const Container = styled.div`
  display: inline-block;
  position: relative;
  // overflow: hidden;
  background-color: #DDDBDD;
  border-radius: 4px;
  color: transparent;
  padding: 0;
  margin: 0;

  * {
    opacity: 0;
    pointer-events: none;
  }

  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
    animation: shimmer 2s infinite;
    content: '';
  }

  @keyframes shimmer {
    100% {
      transform: translateX(100%);
    }
  }
`
